import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FTPClientConnectionInfoDTO, FTPConnectionResponse, ImportConfigurationClient } from "src/app/base/models/models.swagger.generated";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationFormFtpService {
  constructor(private importConfigurationClient: ImportConfigurationClient,) { }

  public testFtpAccess(connectionInfo: FTPClientConnectionInfoDTO): Observable<FTPConnectionResponse> {
    return this.importConfigurationClient.testFtpAccess(connectionInfo);
  }
}